export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6881.83d9b0f4.jpg";